import React from 'react'

export interface RadioButtonWrapperInterface extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  label?: string,
  errorText?: string,
  noMargin?: boolean
}

export const RadioButtonWrapper: React.FC<RadioButtonWrapperInterface> = ({
  label, 
  children,
  errorText,
  className,
  style,
  noMargin,
  ...props
}) => (
  <div
    {...props} 
    className={`${noMargin ? 'm-0' : 'mb-2'} d-flex flex-column ${className}`}
    style={style}
  >
    <label>
      <small>
        {label}
      </small>
    </label>
    <div>
      {children}
    </div>
    <small className="mt-1 text-danger">
      {errorText}
    </small>
  </div>
)